var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1695.06 1200.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4AFC38;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m624.44,12.53C390.27-54.51,125.14,154.18,32.26,478.64c-92.88,324.46,21.66,641.83,255.83,708.87,234.17,67.04,499.3-141.65,592.18-466.11,92.88-324.46-21.66-641.83-255.83-708.87Zm-39.45,304.79c-5.56,67.16-64.51,117.09-131.67,111.53-67.16-5.56-117.09-64.51-111.53-131.67,5.56-67.16,64.51-117.09,131.67-111.53,67.16,5.56,117.09,64.51,111.53,131.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1470.12,266.02c-182.84-52.34-389.86,110.6-462.38,363.94-72.52,253.34,16.91,501.15,199.75,553.49,182.84,52.34,389.86-110.6,462.38-363.94,72.52-253.34-16.91-501.15-199.75-553.49Zm-26.94,293.29c-5.56,67.16-64.51,117.09-131.67,111.53-67.16-5.56-117.09-64.51-111.53-131.67,5.56-67.16,64.51-117.09,131.67-111.53,67.16,5.56,117.09,64.51,111.53,131.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.ad72dbdda21e46a579f5ab69671b5798.svg";
export { ForwardRef as ReactComponent };